export default __webpack_public_path__ + "static/media/SWT0290.34I-20311_-14778_0.c821180c.jpg";